import React, { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getAuth } from "firebase/auth";
import { getApp } from "firebase/app";
import AdminHeader from "../components/AdminHeader";
import { Link, useLocation } from "react-router-dom";
import AdminSidebar from "../components/AdminSidebar";

function DebugButtons() {
  const checkAdmin = async () => {
    const uid = getAuth().currentUser?.uid;
    if (!uid) return alert("No signed-in user.");
    try {
      const snap = await getDoc(doc(db, "admins", uid));
      alert(`admins/${uid} exists? ${snap.exists()}`);
      console.log("Admin doc data:", snap.data());
    } catch (e) {
      console.error("Admin read failed:", e);
      alert("Admin read failed: " + e.message);
    }
  };

  const testWrite = async () => {
    try {
      await setDoc(doc(db, "siteConfig", "global"), { pingAt: new Date() }, { merge: true });
      alert("Write OK!");
    } catch (e) {
      console.error("siteConfig write failed:", e);
      alert("Write failed: " + e.message);
    }
  };

  const uid = getAuth().currentUser?.uid || "—";
  const projectId = getApp().options.projectId || "—";

  return (
    <div className="mt-6 space-y-2 rounded-2xl border border-[#D4FF00]/30 bg-black/60 p-4">
      <div className="text-sm text-gray-300">
        <div>UID: <span className="text-white">{uid}</span></div>
        <div>projectId: <span className="text-white">{projectId}</span></div>
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          className="px-3 py-2 rounded bg-[#D4FF00] text-black font-semibold"
          onClick={checkAdmin}
        >
          Test admin read
        </button>
        <button
          className="px-3 py-2 rounded border border-[#D4FF00] text-[#D4FF00]"
          onClick={testWrite}
        >
          Test siteConfig write
        </button>
      </div>
    </div>
  );
}

export default function Admin() {
  const [promoText, setPromoText] = useState("");
  const [bannerText, setBannerText] = useState("");
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const location = useLocation();

  useEffect(() => {
    const load = async () => {
      try {
        const ref = doc(db, "siteConfig", "global");
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const data = snap.data();
          setPromoText(data.promoText || "");
          setBannerText(data.bannerText || "");
        }
      } catch (e) {
        console.error("Failed to load siteConfig/global:", e);
      }
    };
    load();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);
      setMsg("");
      const ref = doc(db, "siteConfig", "global");
      await setDoc(ref, { promoText, bannerText }, { merge: true });
      setMsg("Updated successfully!");
      setTimeout(() => setMsg(""), 2500);
    } catch (e) {
      setMsg("Update failed. Check console/rules.");
      console.error("handleSave error:", e);
    } finally {
      setSaving(false);
    }
  };

  const navItems = [
    { name: "Site Config", path: "/admin" },
    { name: "User Manager", path: "/admin/users" },
    { name: "Bookings", path: "/admin/bookings" },
    { name: "Revenue", path: "/admin/revenue" }
  ];

  return (
    <>
      <AdminHeader />
      <div className="flex flex-col md:flex-row">
        {/* Sidebar */}
        <div className="w-full md:w-48 bg-black border-b md:border-b-0 p-4">
          <AdminSidebar />
        </div>

        {/* Main Content */}
        <div className="flex-1 px-4 py-8 max-w-2xl mx-auto">
          <div className="mb-6">
            <div className="flex items-center text-[10px] tracking-[0.3em] uppercase text-[#a9ffa2]/70">
              <span>RGC // Admin Ops Console</span>
            </div>
            <h1 className="mt-2 text-3xl md:text-5xl font-extrabold">
              Site <span className="text-accent">Config</span> Room
            </h1>
          </div>

          <div className="space-y-5 rounded-2xl border border-[#D4FF00]/30 bg-black/60 p-5">
            <div>
              <label className="block font-semibold text-sm text-gray-200 mb-1">
                Promo Bar Text
              </label>
              <input
                className="w-full rounded-lg border border-[#D4FF00]/30 bg-neutral-900 text-gray-100 p-2.5 focus:ring-2 focus:ring-[#D4FF00] focus:border-transparent"
                value={promoText}
                onChange={(e) => setPromoText(e.target.value)}
                placeholder="e.g., Grand Opening — 10% off this weekend!"
              />
            </div>

            <div>
              <label className="block font-semibold text-sm text-gray-200 mb-1">
                Banner Text
              </label>
              <input
                className="w-full rounded-lg border border-[#D4FF00]/30 bg-neutral-900 text-gray-100 p-2.5 focus:ring-2 focus:ring-[#D4FF00] focus:border-transparent"
                value={bannerText}
                onChange={(e) => setBannerText(e.target.value)}
                placeholder="e.g., 24/7 PCs • High FPS • Energy Drinks"
              />
            </div>

            <div className="flex flex-wrap items-center gap-3">
              <button
                onClick={handleSave}
                disabled={saving}
                className="px-4 py-2.5 rounded-lg bg-[#D4FF00] text-black font-semibold hover:brightness-90 transition disabled:opacity-60"
              >
                {saving ? "Saving…" : "Save"}
              </button>
              {msg && <span className="text-gray-300">{msg}</span>}
            </div>
          </div>

          {/* Debug tools */}
          <DebugButtons />
        </div>
      </div>
    </>
  );
}
